/**
 * Offline mutation queue. When offline, mutations are stored and applied to local cache;
 * when back online, replayed. Conflicts (server updated after our cache version) surface for admin resolution.
 */

const QUEUE_KEY = 'tt_offline_queue';
const MAX_ITEMS = 100;

function getQueue() {
  try {
    const raw = localStorage.getItem(QUEUE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

function setQueue(items) {
  try {
    localStorage.setItem(QUEUE_KEY, JSON.stringify(items.slice(-MAX_ITEMS)));
  } catch (_) {}
}

export function enqueue(entry) {
  const queue = getQueue();
  const id = `${entry.type}_${Date.now()}_${Math.random().toString(36).slice(2, 9)}`;
  queue.push({ ...entry, id, createdAt: Date.now() });
  setQueue(queue);
  return id;
}

export function getQueueItems() {
  return getQueue();
}

export function removeFromQueue(id) {
  const queue = getQueue().filter((item) => item.id !== id);
  setQueue(queue);
}

export function clearQueue() {
  setQueue([]);
}

export function isOnline() {
  return typeof navigator !== 'undefined' && navigator.onLine === true;
}
